export function getInitialOption(
  properties,
  options = [],
  defaults = {}
) {
  const optionValues = options.map(option => properties[option])

  for (let option in defaults) {
    if (optionValues.every(val => val === defaults[option])) {
      return option
    }
  }

  // Handles when they are null or undefined
  if (optionValues.every(val => !val)) return "none"

  return "custom"
}
